import { useEffect, useState } from "react";
import img1 from "../../../Assets/Home/Truck.png";
import img2 from "../../../Assets/Home/Truck1.png";
import api from "../../../configs/api";
import { showError, showSuccess } from "../../../utils/toastUtils";
import Button from "../Common/Button";

export default function MixMastersContact() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    product: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await api.get("/products?lightweight=true&limit=100");
        setProducts(res.data.data.products || []);
      } catch (err) {
        console.error(err);
        showError("Failed to load products");
      }
    };

    fetchProducts();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const { fullName, email, phone, product } = form;

    if (!fullName.trim()) {
      showError("Please enter your name");
      return false;
    }

    if (!email.trim()) {
      showError("Please enter your email");
      return false;
    }

    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(email)) {
      showError("Invalid email address");
      return false;
    }

    if (!phone.trim()) {
      showError("Please enter your phone number");
      return false;
    }

    if (phone.length < 10) {
      showError("Invalid phone number");
      return false;
    }

    if (!product) {
      showError("Please select a product");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      setLoading(true);

      const res = await api.post("/inquiries", {
        name: form.fullName,
        email: form.email,
        phone: form.phone,
        message: form.message,
        source: "product",
        product: form.product,
      });

      if (res?.data?.success) {
        showSuccess("Message sent! We'll get back to you soon.");

        setForm({
          fullName: "",
          email: "",
          phone: "",
          product: "",
          message: "",
        });
      }
    } catch (err) {
      console.error(err);
      showError(
        err?.response?.data?.message ||
        "Failed to send message. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: "8px",
    border: "1.5px solid #ddd",
    background: "white",
    fontSize: "0.875rem",
    color: "#1a1a2e",
    outline: "none",
    transition: "border-color 0.2s",
    fontFamily: "'Inter', sans-serif",
  };

  const labelStyle = {
    display: "block",
    fontSize: "0.8rem",
    fontWeight: 600,
    color: "#1a1a2e",
    marginBottom: "6px",
    fontFamily: "'Inter', sans-serif",
  };

  return (
    <div
      className="w-full py-8 md:py-10"
      style={{
        background: "#eef0f8",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <style>{`
        .contact-input:focus { border-color: #c020d0 !important; box-shadow: 0 0 0 3px rgba(192,32,208,0.1); }
        .contact-input::placeholder { color: #aaa; }
      `}</style>

      <div className="px-4 sm:px-6 md:px-8 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-start">
          {/* LEFT */}
          <div className="w-full lg:w-auto lg:flex-shrink-0 flex flex-col gap-y-4">
            <p
              className="font-semibold mb-3"
              style={{
                color: "#c020d0",
                fontSize: "0.7rem",
                letterSpacing: "0.18em",
                textTransform: "uppercase",
              }}
            >
              [GET INVOLVED]
            </p>

            <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-[#041122] font-heading leading-relaxed font-semibold mb-5">
              Start Building Something
              <br />
              Amazing With Us Today
            </h2>

            <div className="flex items-center gap-4 mb-7 flex-wrap">
              {["24/7 Support", "Free Consultation", "Certified Experts"].map(
                (item) => (
                  <div key={item} className="flex items-center gap-1.5">
                    <span
                      style={{
                        color: "#c020d0",
                        fontWeight: 700,
                        fontSize: "0.85rem",
                      }}
                    >
                      ✓
                    </span>
                    <span className="text-gray-600 text-xs font-medium">
                      {item}
                    </span>
                  </div>
                ),
              )}
            </div>

            <div className="flex flex-row gap-3 sm:gap-4">
              <div
                className="rounded-xl overflow-hidden flex-1"
                style={{ height: "180px", minWidth: 0 }}
              >
                <img
                  src={img1}
                  alt="MixMasters Plant"
                  className="w-full h-full object-cover"
                />
              </div>

              <div
                className="rounded-xl overflow-hidden flex-1"
                style={{ height: "180px", minWidth: 0 }}
              >
                <img
                  src={img2}
                  alt="MixMasters Trucks"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="h-full w-full flex flex-col justify-between">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label style={labelStyle}>
                  Full Name <span style={{ color: "#e040fb" }}>*</span>
                </label>
                <input
                  placeholder="Enter your full name"
                  className="contact-input"
                  style={inputStyle}
                  type="text"
                  name="fullName"
                  value={form.fullName}
                  onChange={handleChange}
                />
              </div>

              <div>
                <label style={labelStyle}>
                  Email Address <span style={{ color: "#e040fb" }}>*</span>
                </label>
                <input
                  placeholder="Enter your email"
                  className="contact-input"
                  style={inputStyle}
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label style={labelStyle}>
                  Phone Number <span style={{ color: "#e040fb" }}>*</span>
                </label>
                <input
                  placeholder="Enter your phone"
                  className="contact-input"
                  style={inputStyle}
                  type="tel"
                  name="phone"
                  maxLength={10}
                  value={form.phone}
                  onChange={handleChange}
                />
              </div>

              <div>
                <label style={labelStyle}>
                  Select Product <span style={{ color: "#e040fb" }}>*</span>
                </label>
                <select
                  className="contact-input"
                  style={{
                    ...inputStyle,
                    appearance: "none",
                    cursor: "pointer",
                  }}
                  name="product"
                  value={form.product}
                  onChange={handleChange}
                >
                  <option value="">Choose a product</option>

                  {products.map((p) => (
                    <option key={p._id} value={p.name}>
                      {p.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mb-6">
              <label style={labelStyle}>Message</label>
              <textarea
                className="contact-input"
                style={{ ...inputStyle, resize: "none", minHeight: "110px" }}
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Write your message here ..."
              />
            </div>

            <div className="flex justify-start">
              <Button
                text={loading ? "Sending..." : "Send Message"}
                onClick={handleSubmit}
                disabled={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}